import { Component, OnInit } from '@angular/core';
import { BreadcrumbProgressControl } from '@tmhcc-ng-lib/framwork/breadcrumb-progress';
import { Router, Route, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { PageHeaderService } from './page-header.service';
import { take } from 'rxjs/operators';
import { AllowedRoute } from './page-header-navigation/page-header-navigation-def';

@Component({
  selector: 'ae-page-step-nav',
  templateUrl: './page-step-nav.component.html',
  styleUrls: ['./page-step-nav.component.scss']
})
export class PageStepNavComponent implements OnInit {
  breadCrumb1: BreadcrumbProgressControl;
  breadCrumb2: BreadcrumbProgressControl;
  valueSub = new Subscription();
  routersPath: string;
  url: string;
  backwardRoute: string;
  sub: Subscription;
  page: number;
  constructor(
    private pageHeaderService: PageHeaderService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.routersPath = router.url;
  }

  ngOnInit() {
    this.breadCrumb2 = new BreadcrumbProgressControl();
    this.breadCrumb2.titles = [
      'General Information',
      'Coverages',
      'Underwriting Information',
      'Verify & Purchase'
    ];
    this.breadCrumb2.progressIndex = 0;
    this.updateProgressIndex();
    this.updateStepNavigation();
  }

  updateStepNavigation() {
    let disabledBadges = [];
    this.valueSub.add(
      this.pageHeaderService.getBadgeCount.subscribe(badgeCount => {
        this.breadCrumb2.progressIndex = badgeCount;
        if (badgeCount === 0) {
          disabledBadges = [false, true, true, true];
        } else if (badgeCount === 1) {
          disabledBadges = [false, false, true, true];
        } else if (badgeCount === 2) {
          disabledBadges = [false, false, false, true];
        } else {
          disabledBadges = [false, false, false, false];
        }
        this.breadCrumb2.isDisabled = disabledBadges;
      })
    );
  }

  navigate(entity) {
    this.updatePath(entity.clickedIndex);
    this.router.navigate([this.url]);
  }

  updatePath(progressIndex) {
    if (progressIndex === 0) {
      this.url = AllowedRoute.GeneralInfo;
    } else if (progressIndex === 1) {
      this.url = AllowedRoute.Coverage;
    } else if (progressIndex === 2) {
      this.url = AllowedRoute.underwriter;
    } else if (progressIndex === 3) {
      this.url = AllowedRoute.Bind;
    } else {
      this.url = AllowedRoute.Dashboard;
    }
  }

  updateProgressIndex() {
    const path = this.router.url;
    if (path.includes(AllowedRoute.GeneralInfo)) {
      this.breadCrumb2.progressIndex = 0;
    } else if (path === AllowedRoute.Coverage) {
      this.breadCrumb2.progressIndex = 1;
    } else if (path === AllowedRoute.underwriter) {
      this.breadCrumb2.progressIndex = 2;
    } else if (path === AllowedRoute.Bind) {
      this.breadCrumb2.progressIndex = 3;
    } else {
      this.breadCrumb2.progressIndex = 0;
    }
    this.pageHeaderService.setBadgeCounter(this.breadCrumb2.progressIndex);
  }

  backBtn() {
    const path = this.router.url;
  }
}
